import type { ReactNode } from 'react'
import { useI18n } from '../i18n/useI18n'
import type { Equipment, EquipmentSlot as Slot } from '../game/types'

const SLOT_META: Record<Slot, { labelKey: 'equipment_weapon' | 'equipment_tool'; placeholderKey: 'equipment_empty_hands' | 'equipment_no_tool'; glyph: string }> = {
  weapon: { labelKey: 'equipment_weapon', placeholderKey: 'equipment_empty_hands', glyph: '🗡' },
  tool: { labelKey: 'equipment_tool', placeholderKey: 'equipment_no_tool', glyph: '🛠' },
}

type Props = {
  slot: Slot
  equipment: Equipment | null | undefined
  subtitle?: string
  /** Rendered on the right inside the slot row (e.g. unequip). */
  trailing?: ReactNode
}

export function EquipmentSlot({ slot, equipment, subtitle, trailing }: Props) {
  const { t, pick } = useI18n()
  const meta = SLOT_META[slot]
  return (
    <div className="flex items-center gap-3 rounded-md border border-stone-800 bg-stone-800/50 p-2.5">
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-md border border-stone-700 bg-stone-950 text-base">
        {meta.glyph}
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-wider text-stone-500">
          {t(meta.labelKey)}
        </div>
        <div className="truncate text-sm text-stone-100">
          {equipment ? (
            pick(equipment.name)
          ) : (
            <span className="text-stone-500">{t(meta.placeholderKey)}</span>
          )}
        </div>
        {subtitle ? (
          <div className="mt-0.5 text-[10px] tabular-nums text-amber-400/90">{subtitle}</div>
        ) : null}
      </div>
      {trailing ? <div className="shrink-0 self-center">{trailing}</div> : null}
    </div>
  )
}
